import { HEATMAP_FOLDER_ITEM_ID } from "@const/dashboard.constants";
import { Button, ButtonProps } from "antd";
import axios, { AxiosError } from "axios";
import { FC, useEffect } from "react";
import { FaStar } from "react-icons/fa";
import { useAppGlobStore } from "src/appGlobalStore";
import { API_URL } from "src/data/Api";
import { Log } from "src/service/log.service";
import { putApi } from "src/util/apiCalls";
import { GLOB } from "src/util/Glob";

export function getCgFavoriteURL() {
  return `${API_URL.CUSTOM_GROUPS}/${GLOB.selectedItem.itemId}/favorite`;
}

export const XmCgHeatmapFavorite: FC<ButtonProps> = ({ className, ...props }) => {
  const isCgHeatDash = useAppGlobStore(s => s.isCgHeatDash);

  useEffect(() => {
    return () => {
      setIsFav(false);
    };
  }, []);

  function setIsFav(fav: boolean) {
    useAppGlobStore.setState({ isCgHeatDash: fav });
  }

  function resetCgDashMenu() {
    const menu = useAppGlobStore.getState().topMenu;
    menu[0].children.find(mn => mn.itemId === HEATMAP_FOLDER_ITEM_ID).children = null;
    useAppGlobStore.setState({ topMenu: [...menu] });
  }

  const onSelect: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();
    e.preventDefault();

    if (isCgHeatDash) {
      axios.delete(getCgFavoriteURL()).then(resp => {
        setIsFav(false);
        resetCgDashMenu();
      }, (reason: AxiosError) => Log.error('Failed to delete CG heatmap favorite!', reason));
    } else {
      putApi(getCgFavoriteURL()).then(resp => {
        setIsFav(true);
        resetCgDashMenu();
      }, (reason: AxiosError) => Log.error('Failed to add CG heatmap favorite!', reason));
    }
  };

  return <Button className={`xm-cg-heatmap-fav ${isCgHeatDash ? "selected" : ""} ${className}`}
    title={isCgHeatDash ? 'Remove heatmap from dashboard favorites' : 'Add heatmap to dashboard favorites'}
    onClick={onSelect} type='link' size="small" {...props}>
    <FaStar />
  </Button>;
};